import React, { useMemo } from 'react'
import ConfirmModalV2 from '../../components/ConfirmModalV2'
import { APPLICATION_STRINGS } from '../../strings'
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min'

const NetworkPrintErrorModal = ({ showNetworkPrintErrorModal, setShowNetworkPrintErrorModal }) => {
  const history = useHistory()

  const NetworkPrintError = () => {
    return (
      <ConfirmModalV2
        onButtonOneClick={() => setShowNetworkPrintErrorModal(false)}
        onButtonTwoClick={() => history.push('/orders/device-summary')}
        headerText={APPLICATION_STRINGS.NETWORK_PRINTER_ERROR_TITLE}
        subtext={APPLICATION_STRINGS.ORDER_MUST_BE_SYNCED_BEFORE_PRINTING}
        buttonOneText={APPLICATION_STRINGS.OK_BUTTON_TEXT}
        buttonTwoText={'SYNC NOW'}
      />
    )
  }

  const shouldRender = useMemo(() => {
    if (!showNetworkPrintErrorModal) return false

    return true
  }, [showNetworkPrintErrorModal])

  if (!shouldRender) {
    return null
  }

  return <NetworkPrintError />
}

export default NetworkPrintErrorModal
